import { memo } from 'react';

import ChevronIconSVG from '@/assets/chevron-down-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

export type ChevronIconProps = Omit<IconProps, 'SVGComponent'> & {
  rotation: 'up' | 'right' | 'down' | 'left';
};

const IChevronIcon = ({ rotation, className, ...rest }: ChevronIconProps) => {
  /* prettier-ignore */
  const rotationStyles = [
    rotation === 'up' && 'rotate-180',
    rotation === 'right' && 'rotate-270',
    rotation === 'down' && 'rotate-0',
    rotation === 'left' && 'rotate-90',
  ];

  return <Icon SVGComponent={ChevronIconSVG} className={merge(rotationStyles, className)} {...rest} />;
};

export const ChevronIcon = memo(IChevronIcon) as typeof IChevronIcon;
